import React from "react";
import { Link } from "react-router-dom";

export default function AuthShell({ title, subtitle, footer, children, side = "right" }) {
  const sideContent = (
    <div className="relative hidden lg:flex flex-col justify-between bg-[#1A1A1A] text-[#FDFCFB] p-12 xl:p-16 overflow-hidden">
      <Link to="/" className="font-serif-display text-3xl tracking-tight inline-block">
        Heritex<span className="text-[#FDFCFB]/40">.</span>
      </Link>

      <div>
        <div className="caption !text-[#FDFCFB]/40 mb-8">Heritex CRM · Self-serve</div>
        <h2 className="font-serif-display text-5xl xl:text-6xl leading-[1.05] tracking-tight">
          One calm system <span className="italic">for every customer</span> conversation.
        </h2>
        <p className="mt-8 max-w-md text-[#FDFCFB]/70 leading-relaxed">
          Sales pipelines, contacts, companies, activities — built around the way
          your team actually works. Pick an industry pack and you're live in
          minutes.
        </p>
      </div>

      <div className="font-mono-tech text-[11px] tracking-[0.18em] uppercase text-[#FDFCFB]/40">
        © {new Date().getFullYear()} Heritex Innovations Pvt. Ltd.
      </div>

      {/* decorative noise */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.05] mix-blend-overlay pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")",
        }}
      />
    </div>
  );

  return (
    <main className="min-h-screen bg-[#FDFCFB] grid grid-cols-1 lg:grid-cols-2">
      {side === "left" && sideContent}

      <div className="flex flex-col justify-center px-6 sm:px-10 md:px-16 xl:px-24 py-10 md:py-16">
        <Link
          to="/"
          className="lg:hidden font-serif-display text-2xl tracking-tight inline-block mb-10"
        >
          Heritex<span className="text-[#6B6A68]">.</span>
        </Link>

        <div className="max-w-md w-full mx-auto lg:mx-0">
          <div className="caption mb-4">Heritex CRM</div>
          <h1 className="font-serif-display text-4xl md:text-5xl tracking-tight leading-[1.05] text-[#1A1A1A]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-[#6B6A68] leading-relaxed">{subtitle}</p>
          )}

          <div className="mt-10">{children}</div>

          {footer && <div className="mt-8 text-sm text-[#6B6A68]">{footer}</div>}
        </div>
      </div>

      {side === "right" && sideContent}
    </main>
  );
}
